<template>
    <div id="main-import">
        <!-- CAIXA DE ALERTAS -->
        <div class="alert-wrapper">
            <alert-container :messages="msgs" />
        </div>

        <div class="page">
            <div class="listing-header">
                <div class="title-breadcrumb">
                    <h1 class="title">{{$t('importar-lps')}}</h1>
                    <nav class="breadcrumb" aria-label="breadcrumbs">
                        <ul>
                            <li><a class="a-inativo">{{$t('promotor')}}</a></li>
                            <li><a class="a-inativo">{{$t('cadastros')}}</a></li>
                            <li><a @click="$router.push({name: 'lpss'})">{{$t('lps')}}</a></li>
                            <li><a aria-current="page">{{ $t('importar') }}</a></li>
                        </ul>
                    </nav>
                </div>
                <div class="header-buttons">
                    <button class="delete-btn" type="button" @click="$router.push({name: 'lpss'})">
                        {{ $t('voltar') }}
                    </button>
                </div>
            </div>
            <hr>
            <div class="import-content">
                <div class="download-description">
                    {{ $t('msg-download-example') }}
                </div>
                <div class="download-link">
                    <button type="button" class="save-btn" @click="downloadExampleCSV">
                        <b-icon icon="file-excel"/>
                        <span class="text">{{ $t('msg-download-btn') }}</span>
                    </button>
                </div>
                <hr>
                <div class="upload-description">
                    {{ $t('msg-import') }}
                </div>
                <div class="picker-wrapper">
                    <file-picker
                        ref="filePicker"
                        class="upload-picker"
                        v-model="file"
                        accepted=".csv"
                        :allowedtypes="['application/vnd.ms-excel', 'text/csv']"
                        @alert="showMessageComp"
                    />
                </div>
                <div class="upload-submit">
                    <button type="button" class="save-btn" @click="importData" :disabled="!file || importing">
                        {{ $t('importar-registros') }}
                        <button-loader :isSaving="importing" />
                    </button>
                </div>
                <hr>
                <div class="errors-wrapper">
                    <div class="error"
                        v-for="(e, i) in errors"
                        :key="i"
                    >
                        <span>
                            {{ `${$t('linha')} ${e.line}: ` }}
                        </span>
                        <span v-if="needFieldName.includes(e.error)">
                            {{ $t(e.error, { c: e.field }) }}.
                        </span>
                        <span v-else>
                            {{ $t(e.error) }}.
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FilePicker from "@/components/shared/form/FilePicker";
import Message from "@/models/Message";
import ImportacaoService from "@/services/promotor/ImportacaoService";

export default {
    data() {
        return {
            msgs: [],
            file: null,
            service: null,
            errors: [],
            needFieldName: [
                'importacao-erro-campo', 'importacao-erro-number-format', 
                'importacao-erro-date-format', 'importacao-erro-required-field',
                'importacao-erro-field-greater-than-allowed',
                'importacao-erro-field-smaller-than-allowed',
            ],
            importing: false
        };
    },
    components: {
        FilePicker,
    },
    created () {
        this.service = new ImportacaoService(this.$http, this.$route);

        this.permissao = this.hasPermissionAccess("promotor", "cadastros", "lpss");
        if ( !this.permissao.read ){
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'importar-lps' }
            });
        }
    },
    methods: {
        showMessageComp (msg) {
            const {type, message} = msg;

            this.msgs.push(
                new Message(type, message, true)
            );
        },
        showMessage (type, message) {
            this.msgs.push(
                new Message(type, message, true)
            );
        },
        importData () {
            this.importing = true;

            this.service.importProLPS(this.file)
                .then(r => {
                    if (r.status != 200) {
                        console.error(`Erro status ${r.status} na importação LPS.`);
                        console.error(r.message ? r.message : 'Sem mensagem');

                        if (r.message.startsWith('msg-')) {
                            this.showMessage('error', r.message);
                        } else {
                            this.showMessage('error', 'msg-erro-import-process');
                        }
                    } else if (!r.content.success) {
                        console.error(`Erro nos dados do CSV.`);
                        this.errors = r.content.errors;
                        this.showMessage('error', 'msg-erro-import-data');
                    } else {
                        this.file = null;
                        this.$refs.filePicker.clearFile();
                        this.errors = [];
                        this.showMessage('success', 'msg-success-import');
                        setTimeout(() => {
                            this.$router.push({ name: 'lpss' })
                        }, 2000);
                    }
                })
                .catch(e => {
                    console.error('Erro na importação pro_produto.', e);
                    this.showMessage('error', 'msg-erro-import-process');
                })
                .finally(_ => {
                    this.importing = false;
                });
        },
        downloadExampleCSV () {
            var filename, link, blob, url;

            let csv = 'CODIGO;CIDADE;REGIAO;REDE;BANDEIRA;NOME;RSOCIAL;ENDERECO;NUMERO;BAIRRO;CEP;IE;CNPJ;TELEFONE;FAX;CELULAR;EMAIL;LATITUDE;LONGITUDE;FACEBOOK;LINKEDIN;INSTAGRAM;SITE\n'
                    + '999999X;PR-CASCAVEL;SUL;NOME DA REDE;NOME DA BANDEIRA;NOME DA EMPRESA;RAZAO SOCIAL;AV. EXEMPLO;100;NOME DO BAIRRO;85803000;1111111111;00000000000000;45999996666;45999997777;45999998888;email@exemplo.com.br;"-25,119865";"-53,218392";www.facebook.com;www.linkedin.com;www.instagram.com;www.exemplo.com.br';

            blob = new Blob([csv], {type: 'data:application/vnd.ms-excel;'});
            url = URL.createObjectURL(blob);

            filename = 'pro_lps.csv';

            link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
        }
    }
};
</script>

<style lang="scss">
#main-import {
    padding: 0 20px;

    .page {
        font-weight: 600;
        padding: 20px;
        background-color: $sovis-white;
        color: $darker-gray-color;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);

        .import-content {
            margin-top: 25px;

            .download-description {
                padding: 0 4px 10px 4px;
            }

            .upload-description {
                padding: 0 4px 20px 4px;
            }

            .download-link {
                display: flex;
                align-items: center;
                justify-content: center;
                padding-top: 10px;
            }

            button {
                display: flex;
                align-items: center;
                padding: 0 10px;
                min-height: 40px;

                .text {
                    padding-left: 5px;
                }
            }

            .picker-wrapper {
                width: 100%;
                display: flex;
                justify-content: center;

                .upload-picker {
                    width: 75%;
                    max-width: 1000px;
                    height: 100px;
                }
            }

            .upload-submit {
                display: flex;
                width: 100%;
                justify-content: center;
                padding-top: 20px;
            }

            .errors-wrapper {
                .error {
                    font-size: 14px;
                    font-weight: 600;
                    color: $red-alert;
                    padding: 5px 0;
                }
            }
        }
    }
}

@media only screen and (max-width: 760px) {
    #main-import {
        .page {
            .listing-header {
                flex-wrap: wrap;

                .title-breadcrum, .header-buttons {
                    width: 100%;
                }

                .header-buttons {
                    flex-wrap: wrap;
                    margin-top: 10px;

                    button {
                        margin-bottom: 10px !important;
                        margin-left: 0 !important;
                    }
                }
            }

            .import-content {
                .picker-wrapper {
                    .upload-picker {
                        width: 100%;
                    }
                }
            }

            button {
                width: 100%;
                justify-content: center;
            }
        }
    }
}
</style>